// Generic API error type guard for React Query

// Define a generic API error interface
interface ApiError<T = unknown> {
    status: number;
    data?: T;
}

export function isApiError<T = unknown>(error: unknown): error is ApiError<T> {
    return (
        typeof error === "object" &&
        error !== null &&
        "status" in error &&
        typeof (error as { status?: unknown }).status === "number"
    );
}
